module.exports = __webpack_public_path__ + "static/media/forklift_inactive.332208d3.svg";